export type CanvasSizeType =
    | 'custom'
    | 'a4-landscape'
    | 'a3-portrait'
    | 'a3-landscape'
    | 'letter-portrait'
    | 'letter-landscape'
    | 'square-1024'
    | 'square-2048'
    | 'hd'
    | 'full-hd'
    | '4k'
    | 'visiting-card'
    | 'cover-9-5x4-25'
    | 'letterhead-a4';

export interface CanvasSize {
    type: CanvasSizeType;
    name: string;
    width: number;
    height: number;
    unit?: string;
}

// Standard canvas sizes (in pixels at 96 DPI)
export const CANVAS_SIZES: CanvasSize[] = [
    { type: 'custom', name: 'Custom', width: 800, height: 600 },
    { type: 'visiting-card', name: 'Visiting Card', width: 340, height: 204, unit: '90×54mm' },
    { type: 'cover-9-5x4-25', name: 'Envelope 9.5"×4.25"', width: 912, height: 408, unit: 'Envelope (9.5×4.25 in)' },
    { type: 'letterhead-a4', name: 'Letterhead (A4)', width: 794, height: 1123, unit: 'Letterhead (210×297mm)' },
    { type: 'a4-landscape', name: 'A4 Landscape', width: 1123, height: 794, unit: 'A4 (297×210mm)' },
    { type: 'a3-portrait', name: 'A3 Portrait', width: 1123, height: 1587, unit: 'A3 (297×420mm)' },
    { type: 'a3-landscape', name: 'A3 Landscape', width: 1587, height: 1123, unit: 'A3 (420×297mm)' },
    { type: 'letter-portrait', name: 'Letter Portrait', width: 816, height: 1056, unit: 'Letter (8.5×11")' },
    { type: 'letter-landscape', name: 'Letter Landscape', width: 1056, height: 816, unit: 'Letter (11×8.5")' },
    { type: 'square-1024', name: 'Square 1024', width: 1024, height: 1024 },
    { type: 'square-2048', name: 'Square 2048', width: 2048, height: 2048 },
    { type: 'hd', name: 'HD (720p)', width: 1280, height: 720 },
    { type: 'full-hd', name: 'Full HD (1080p)', width: 1920, height: 1080 },
    { type: '4k', name: '4K (2160p)', width: 3840, height: 2160 }
];
